export default __webpack_public_path__ + "static/dont-detach-motion-from-source-e05a41f2be34de501b9ed10c6a8ae54f.png";